import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Credentials, CredentialsService } from './credentials.service';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api-service/api.service';
import { APIURL } from '../apis';
import { LoginResponse } from '../models/login-response';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { PermissionsService } from '@app/core/permissions/permissions.service';

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

export interface LoginReqBody {
  email: string;
  password: string;
}

/**
 * Provides a base for authentication workflow.
 * The login/logout methods should be replaced with proper implementation.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private httpClient: HttpClient,
    private credentialsService: CredentialsService,
    private api: ApiRequestService,
    private apiService: ApiService,
    private permissionsService: PermissionsService
  ) {}

  /**
   * Authenticates the user.
   * @param context The login parameters.
   * @return The user credentials.
   */
  login(context: LoginContext): Observable<Credentials> {
    const reqBody: LoginReqBody = {
      email: context.username,
      password: context.password
    };
    return this.api.post(APIURL.login, reqBody).pipe(
      map((body: LoginResponse) => {
        const data: Credentials = {
          username: body.data.user_name,
          token: body.data.access_token,
          userId: body.data.user_id
        };
        this.credentialsService.setCredentials(data, context.remember);
        return data;
      })
    );
  }

  /**
   * Logs out the user and clear credentials.
   * @return True if the user was logged out successfully.
   */
  logout(): Observable<boolean> {
    // Customize credentials invalidation here
    // const savedToken = this.credentialsService.credentials.token;
    // const reqBody = {
    //   token: savedToken
    // };
    // this.credentialsService.setCredentials();
    this.permissionsService.setPermissions([]);
    return this.apiService.postReq(APIURL.logout, {});
  }
}
